import { useSetAtom } from 'jotai';
import { useState } from 'react';
import { toastDataAtom } from '@/atoms/toast';
import { UserConfigPutMutationParams } from '@/types/userConfigs';
import { useUpsertUserConfig } from './useUpsertUserConfig';

export const useOptimisticUserConfigUpdate = <T,>(savedValue: T, toastName?: string) => {
  const upsertUserConfig = useUpsertUserConfig();
  const setToastData = useSetAtom(toastDataAtom);
  const [localValue, setLocalValue] = useState<T>(savedValue);

  const updateUserConfigOptimistically = async (mutationParams: UserConfigPutMutationParams, newValue: T) => {
    // Only call API if we have a new value, different value
    if (newValue !== localValue) {
      setLocalValue(newValue);
      const { isSuccess } = await upsertUserConfig(mutationParams);

      // If API call fails revert local state and set error state
      if (!isSuccess) {
        setLocalValue(savedValue);
      }

      if (toastName) {
        setToastData({ toastName, type: isSuccess ? 'success' : 'error' });
      }
    }
  };

  return { updateUserConfigOptimistically, localValue };
};
